import { useCallback, useRef } from 'react';

export const useDebounce = <Args extends unknown[], Result>(
  func: (...args: Args) => Result,
  delay: number,
): ((...args: Args) => Promise<Awaited<Result>>) => {
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return useCallback(
    async (...args: Args): Promise<Awaited<Result>> => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }

      await new Promise<void>(resolve => {
        timeoutIdRef.current = setTimeout(resolve, delay);
      });

      return await func(...args);
    },
    [func, delay],
  );
};
